import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=34c5ae84&"
import script from "./ProductForm.vue?vue&type=script&lang=ts&"
export * from "./ProductForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports